import { render } from "./ChatIA.vue?vue&type=template&id=177b3f31&scoped=true"
import script from "./ChatIA.vue?vue&type=script&lang=js"
export * from "./ChatIA.vue?vue&type=script&lang=js"

import "./ChatIA.vue?vue&type=style&index=0&id=177b3f31&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177b3f31"]])

export default __exports__